import { render } from "./SelfieInstructionFooter.vue?vue&type=template&id=2691ac34"
import script from "./SelfieInstructionFooter.vue?vue&type=script&lang=js"
export * from "./SelfieInstructionFooter.vue?vue&type=script&lang=js"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__